var token = process.env.REACT_APP_API_KEY

export const headers = {
    headers: {
        'Authorization': token
    }
}